export interface Testimonial {
  id: string;
  quote: string;
  author: string;
  company: string;
  image: string;
  imageAlt: string;
  badge: string;
}

export const testimonials: Testimonial[] = [
  {
    id: "1",
    image: "/depoimento/Botequim da Frau.webp",
    imageAlt: "Botequim da Frau - Case de Sucesso RTL Energia",
    badge: "⚡ SEM INSTALAÇÕES",
    quote: "Os altos custos de energia aqui no Botequim eram um grande problema. A RTL trouxe uma solução que eu nem sabia que existia, com direito a uma economia imediata sem instalação de equipamentos. Agora tenho mais tranquilidade para investir em outros aspectos do negócio.",
    author: "Gisele",
    company: "Botequim da Frau • Cliente RTL"
  },
  {
    id: "2",
    image: "/depoimento/casa confraria.webp",
    imageAlt: "Casa Confraria - Case de Sucesso RTL Energia",
    badge: "📈 ESTABILIDADE",
    quote: "Conheci a RTL através de recomendação de um amigo, dono de comércio, que disse estar usando os serviços da RTL e que estava tendo ótimos resultados. Como meu gasto de energia aqui no pub é muito alto, fui atrás de fechar com a RTL. O processo foi simples e sem burocracias, reduzindo o custo da minha operação.",
    author: "Mateus",
    company: "Casa Confraria • Cliente RTL"
  },
  {
    id: "3",
    image: "/depoimento/gow.webp",
    imageAlt: "GOW! Consultoria Imobiliária - Case de Sucesso RTL Energia",
    badge: "💰 ECONOMIA REAL",
    quote: "O processo todo foi bem tranquilo. Não houve custo algum de instalação e depois que assinamos o contrato, nossa fatura de energia do mês seguinte já veio bem abaixo do comum. Esta redução de custo foi essencial para que pudéssemos investir mais dinheiro em tráfego, aumentando nosso faturamento mensal.",
    author: "Carlos",
    company: "GOW! Consultoria Imobiliária • Cliente RTL" 
 }
]; 